var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    id: "Help",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M345.1 77.1C317.6 56.2 286.6 49 247.3 49c-29.8 0-55.3 6.1-75.5 19.7C142 89 128 123.1 128 177h76.8c0-14.4-1.4-29.9 7-43.2 8.4-13.3 20.1-23.5 40.2-23.5 20.4 0 30.9 5.9 40.8 18.1 8.4 10.4 11.6 22.8 11.6 36 0 11.4-5.8 21.9-12.7 31.4-3.8 5.6-8.8 10.6-15.1 15.4 0 0-41.5 24.7-56.1 48.1-10.9 17.4-14.8 39.2-15.7 65.3-.1 1.9.6 5.8 7.2 5.8h61.8c5.8 0 7-4.4 7.1-6.2.4-9.5 1.6-24.1 3.3-29.6 3.3-10.4 9.7-19.5 19.7-27.3l20.7-14.3c18.7-14.6 33.6-26.5 40.2-35.9 11.3-15.4 19.2-34.4 19.2-56.9 0-36.7-13.5-63.8-38.9-83.1zM242 370.2c-25.9-.8-47.3 17.2-48.2 45.3-.8 28.2 19.5 46.7 45.5 47.5 27 .8 47.9-16.6 48.7-44.7.8-28.1-19-47.3-46-48.1z",
    fill: "#2c4c4c",
    className: "color000000 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/helpIcon.64ac68d43f0b499c69f544a3395430ff.svg";
export { ForwardRef as ReactComponent };